import styled, { css } from 'styled-components';

export const BackgroundItem = styled.div<{ $isActive: boolean }>`
  background-color: ${({ theme }) => theme.colors['pure-black']};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  transition: opacity 1s;
  opacity: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;

  ${({ $isActive }) =>
    $isActive &&
    css`
      opacity: 1;
    `};
`;
